const rIC = window.requestIdleCallback || window.setTimeout;
export default rIC;

export const cancelIC = window.cancelIdleCallback || window.clearTimeout;
